<template>
    <div class="content_box">
		<div class="head_box">
            <div v-for="item,index in headList" :key="index">
                <router-link class="head_center" :to="item.to">
                    {{ item.name }}<span style="margin-left: 0.3rem;" v-if="headList.length - 1!=index">/</span>
                </router-link>
            </div>
        </div>
        <div class="main_box">
            <img class="main_img" src="@/assets/home/logo.png" alt="">
            <div class="main_center">
                服务热线：{{ formInfo.service_hotline }}<br/>
                市  场  部：{{ formInfo.marketing_department }}<br/>
                <span style="display: flex;align-items: center;">
                    地址：{{ formInfo.address }}
                    <img class="main_image" src="@/assets/home/dz.png" alt="">
                </span>
                邮箱：{{ formInfo.email }}
            </div>
            <div class="main_right">
                <img class="main_right_img" :src="formInfo.weixin" alt="">
                微信二维码
            </div>
            <div class="main_right">
                <img class="main_right_img" :src="formInfo.qq" alt="">
                 QQ 二维码
            </div>
        </div>
        <div class="head_box foot_text" style="background: #0059AA;">
            Copyright © 2025 山东蓝川环保股份有限公司
            <span style="margin-left: 1.6rem;">鲁ICP备15032963号-1 </span>
        </div>
	</div>
</template>

<script>
import { getContactInfo } from "@/api/api";
export default {
    name: "FootIndex",
    props: {
        msg: String,
    },
	data() {
		return {
            headList: [{
				name: '首页',
				to: {
					path: '/',
				}
			}, {
				name: '企业简介',
				to: {
					path: '/intro',
				}
			}, {
				name: '工程项目',
				to: {
					path: '/article',
				}
			}, {
				name: '企业资质',
				to: {
					path: '/resource',
				}
			}, {
				name: '动态信息',
				to: {
					path: '/message',
				}
			}, {
				name: '联系我们',
				to: {
					path: '/my',
				}
			}],
            formInfo: {}
		};
	},
    mounted() {
        this.getLists();
    },
    methods: {
        getLists() {
            getContactInfo({
                id: 1
            }).then(res => {
                if(res.code === 0){
                    this.formInfo = res.data;
                }
            })
        }
    },
};
</script>

<style scoped lang="less">
.content_box{
	width: 100%;
	background: #EEF5FB;
	display: flex;
    flex-direction: column;
	align-items: center;

    .head_box {
        width: 100%;
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 0.01rem solid #2F6AAA;

        .head_center {
            display: flex;
            align-items: center;
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 0.16rem;
            color: #0059AA;
            margin-right: 0.3rem;
            cursor: pointer;
        }
    }
    .main_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.33rem 0 0.54rem 0;

        .main_img {
            width: 1.28rem;
            height: 1.34rem;
            margin-right: 0.45rem;
            object-fit: contain;
        }
        .main_center {
            display: flex;
            flex-direction: column;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            font-size: 0.17rem;
            color: #000000;
            line-height: 0.3rem;
            margin-right: 3rem;

            .main_image {
                width: 0.14rem;
                height: 0.18rem;
                margin-left: 0.1rem;
            }
        }
        .main_right {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            font-size: 0.16rem;
            color: #000000;
            margin-left: 0.6rem;

            .main_right_img {
                width: 0.94rem;
                height: 0.94rem;
                margin-bottom: 0.06rem;
            }
        }
    }
    .foot_text {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 0.14rem;
        color: #FFFFFF;
    }
}
</style>
